var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "modal-card" },
    [
      _vm.isLoadingOverlay
        ? _c("b-loading", {
            attrs: {
              "is-full-page": true,
              active: _vm.isLoadingOverlay,
              "can-cancel": false,
            },
            on: {
              "update:active": function ($event) {
                _vm.isLoadingOverlay = $event
              },
            },
          })
        : _vm._e(),
      _c("header", { staticClass: "modal-card-head" }, [
        _c("p", { staticClass: "modal-card-title" }, [
          _vm._v(" " + _vm._s(_vm.$t("component.annotation.annotate")) + " "),
        ]),
      ]),
      _c(
        "section",
        { staticClass: "modal-card-body" },
        [
          _c(
            "b-field",
            {
              attrs: {
                label: _vm.$t(
                  "component.annotation.annotation_modal.create_for"
                ),
                type: {
                  "is-danger": _vm.errors.has(
                    _vm.$t("component.annotation.annotation_modal.create_for")
                  ),
                  "is-warning": _vm.noDataSources().length > 0,
                },
                message: _vm.errors.first(
                  _vm.$t("component.annotation.annotation_modal.create_for")
                ),
                horizontal: "",
              },
            },
            [
              _c(
                "div",
                { staticClass: "is-flex is-flex-direction-column" },
                [
                  _c("b-taginput", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "'required'",
                      },
                    ],
                    attrs: {
                      data: _vm.filteredTags,
                      autocomplete: "",
                      "allow-new": false,
                      "open-on-focus": true,
                      field: "name",
                      name: _vm.$t(
                        "component.annotation.annotation_modal.create_for"
                      ),
                      icon: "arrow-right",
                      placeholder: _vm.$t(
                        "component.annotation.annotation_modal.add_logger"
                      ),
                      "custom-formatter": _vm.formatSourceOutput,
                    },
                    on: { typing: _vm.filterTags, add: _vm.addTag },
                    scopedSlots: _vm._u([
                      {
                        key: "selected",
                        fn: function ({ tags }) {
                          return _vm._l(tags, function (tag, index) {
                            return _c(
                              "span",
                              { key: index, staticClass: "tag is-medium" },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.formatSourceOutput(tag)) +
                                    " "
                                ),
                                _c("button", {
                                  staticClass: "delete is-small",
                                  on: {
                                    click: function ($event) {
                                      return _vm.removeTag(tag, index)
                                    },
                                  },
                                }),
                              ]
                            )
                          })
                        },
                      },
                    ]),
                    model: {
                      value: _vm.selectedTags,
                      callback: function ($$v) {
                        _vm.selectedTags = $$v
                      },
                      expression: "selectedTags",
                    },
                  }),
                  _vm.noDataSources().length > 0
                    ? _c(
                        "p",
                        {
                          staticClass:
                            "has-text-grey is-italic has-text-right mt-2",
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$tc(
                                  "component.annotation.annotation_modal.error_mgs.no_records",
                                  _vm.noDataSources().length,
                                  { sources: _vm.noDataSources().join(", ") }
                                )
                              ) +
                              " "
                          ),
                        ]
                      )
                    : _vm._e(),
                ],
                1
              ),
            ]
          ),
          _c(
            "b-field",
            {
              attrs: {
                label: _vm.$t("component.report.configuration.modal.from"),
                type: {
                  "is-danger": _vm.errors.has(
                    _vm.$t("component.report.configuration.modal.from")
                  ),
                },
                message: _vm.errors.first(
                  _vm.$t("component.report.configuration.modal.from")
                ),
                horizontal: "",
              },
            },
            [
              _c("b-datetimepicker", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required",
                    expression: "'required'",
                  },
                ],
                attrs: {
                  name: _vm.$t("component.report.configuration.modal.from"),
                  placeholder: _vm.$t(
                    "component.report.month_picker.placeholder"
                  ),
                  "icon-right": _vm.dateTimeFrom ? "close-circle" : "",
                  "icon-right-clickable": "",
                  "first-day-of-week": 1,
                  "mobile-native": false,
                  "max-date": _vm.today,
                  timepicker: { hourFormat: _vm.hourFormat },
                  "datetime-formatter": (date) =>
                    _vm.dateTimeManager.formatDateTimeInInput(date),
                  expanded: "",
                },
                on: { "icon-right-click": _vm.clearDateTimeFrom },
                model: {
                  value: _vm.dateTimeFrom,
                  callback: function ($$v) {
                    _vm.dateTimeFrom = $$v
                  },
                  expression: "dateTimeFrom",
                },
              }),
            ],
            1
          ),
          _c(
            "b-field",
            {
              attrs: {
                label: _vm.$t("component.report.configuration.modal.to"),
                type: {
                  "is-danger": _vm.errors.has(
                    _vm.$t("component.report.configuration.modal.to")
                  ),
                },
                message: _vm.errors.first(
                  _vm.$t("component.report.configuration.modal.to")
                ),
                horizontal: "",
              },
            },
            [
              _c("b-datetimepicker", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required",
                    expression: "'required'",
                  },
                ],
                attrs: {
                  name: _vm.$t("component.report.configuration.modal.to"),
                  placeholder: _vm.$t(
                    "component.report.month_picker.placeholder"
                  ),
                  "icon-right": _vm.dateTimeTo ? "close-circle" : "",
                  "icon-right-clickable": "",
                  "first-day-of-week": 1,
                  "mobile-native": false,
                  "max-date": _vm.today,
                  timepicker: { hourFormat: _vm.hourFormat },
                  "datetime-formatter": (date) =>
                    _vm.dateTimeManager.formatDateTimeInInput(date),
                  expanded: "",
                },
                on: { "icon-right-click": _vm.clearDateTimeTo },
                model: {
                  value: _vm.dateTimeTo,
                  callback: function ($$v) {
                    _vm.dateTimeTo = $$v
                  },
                  expression: "dateTimeTo",
                },
              }),
            ],
            1
          ),
          _c(
            "b-field",
            {
              attrs: {
                label: _vm.$t("component.report.create_annotation.text"),
                type: {
                  "is-danger": _vm.errors.has(
                    _vm.$t("component.report.create_annotation.text")
                  ),
                },
                message: _vm.errors.first(
                  _vm.$t("component.report.create_annotation.text")
                ),
                horizontal: "",
              },
            },
            [
              _c(
                "div",
                [
                  _c(
                    "b-select",
                    {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required",
                          expression: "'required'",
                        },
                      ],
                      staticClass: "mb-3",
                      attrs: {
                        name: _vm.$t("component.report.create_annotation.text"),
                        placeholder: _vm.$t(
                          "component.report.create_annotation.placeholder"
                        ),
                        expanded: "",
                      },
                      model: {
                        value: _vm.predefinedAnnotationText,
                        callback: function ($$v) {
                          _vm.predefinedAnnotationText = $$v
                        },
                        expression: "predefinedAnnotationText",
                      },
                    },
                    _vm._l(_vm.PredefinedText, function (annotation) {
                      return _c(
                        "option",
                        { key: annotation, domProps: { value: annotation } },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t(
                                  `component.report.create_annotation.predefined.${annotation}`
                                )
                              ) +
                              " "
                          ),
                        ]
                      )
                    }),
                    0
                  ),
                  _vm.predefinedAnnotationText === _vm.PredefinedText.OWN
                    ? _c("b-input", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required|max:350",
                            expression: "'required|max:350'",
                          },
                        ],
                        attrs: {
                          type: "textarea",
                          name: _vm.$t(
                            "component.report.create_annotation.text"
                          ),
                          expanded: "",
                          maxlength: "350",
                        },
                        model: {
                          value: _vm.customAnnotationText,
                          callback: function ($$v) {
                            _vm.customAnnotationText = $$v
                          },
                          expression: "customAnnotationText",
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ]
          ),
          _c("section", [
            !_vm.hasDataForTimerange
              ? _c("div", { staticClass: "empty-chart-data" }, [
                  _c("p", [_vm._v(_vm._s(_vm.$t("component.report.no_data")))]),
                ])
              : _vm._e(),
            _c("div", { attrs: { id: _vm.chartId, width: "auto" } }),
          ]),
        ],
        1
      ),
      _c("footer", { staticClass: "modal-card-foot is-block" }, [
        _c("div", { staticClass: "level is-mobile" }, [
          _c(
            "div",
            { staticClass: "level-left" },
            [
              _c(
                "b-button",
                {
                  staticClass: "level-item",
                  on: {
                    click: function ($event) {
                      return _vm.resultRetrieved(false)
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("generals.close")))]
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "level-right" },
            [
              _c(
                "b-button",
                {
                  staticClass: "level-item",
                  attrs: { type: "is-primary" },
                  on: {
                    click: function ($event) {
                      return _vm.validateBeforeSubmit()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("generals.create")))]
              ),
            ],
            1
          ),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }